<script setup lang="ts">
    import { InputRow, Combobox } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';
    // import { computed } from 'vue';
    // import type { SelectOption } from '@/types';
    // import { useI18n } from 'vue-i18n';
    import { Checkbox } from '@/components/ui/checkbox';
    import { Label } from '@/components/ui/label';
    import { Alert } from '@/components/ui/alert';

    // const { tm } = useI18n();

    // const countryOptions = computed<SelectOption[]>(() => {
    //     const map = tm('employee.address.country_codes_array') as Record<string, string>;
    //     return Object.entries(map).map(([value, label]) => ({ value, label }));
    // });

    defineProps<{
        form: any;
    }>();
</script>

<template>
    <div class="grid gap-3">
        <Label
            for="use_iban"
            class="flex cursor-pointer items-center"
        >
            <Checkbox
                v-model="form.bank.use_iban"
                id="use_iban"
            />
            <span>{{ $t('employee.bank.non_danish_account') }}</span>
        </Label>
        <Alert
            v-if="form.bank.use_iban"
            variant="warning"
        >
            {{ $t('employee.bank.transfer_manually') }}
        </Alert>
        <InputRow
            v-if="!form.bank.use_iban"
            :form="form"
            name="bank_reg"
            label="employee.bank.bank_reg"
            error-key="bank.bank_reg"
        >
            <Input
                id="bank_reg"
                v-model="form.bank.bank_reg"
                :placeholder="$t('employee.bank.bank_reg')"
            />
        </InputRow>
        <InputRow
            v-if="!form.bank.use_iban"
            :form="form"
            name="bank_account"
            label="employee.bank.bank_account"
            error-key="bank.bank_account"
        >
            <Input
                id="bank_account"
                v-model="form.bank.bank_account"
                :placeholder="$t('employee.bank.bank_account')"
            />
        </InputRow>
        <InputRow
            v-if="form.bank.use_iban"
            :form="form"
            name="iban"
            label="employee.bank.iban"
            error-key="bank.iban"
        >
            <Input
                id="iban"
                v-model="form.bank.iban"
                :placeholder="$t('employee.bank.iban')"
            />
        </InputRow>
        <InputRow
            v-if="form.bank.use_iban"
            :form="form"
            name="swift"
            label="employee.bank.swift"
            error-key="bank.swift"
        >
            <Input
                id="swift"
                v-model="form.bank.swift"
                :placeholder="$t('employee.bank.swift')"
            />
        </InputRow>
    </div>
</template>
